import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

import s from './hb-review.scss';
import HbButton from '../HbButton/HbButton';

class HbReview extends PureComponent {
  static propTypes = {
    displayErrorMessage: PropTypes.bool,
    errorMessages: PropTypes.string,
    maxLength: PropTypes.number,
    onKeyUp: PropTypes.func,
    letterCount: PropTypes.number,
    sendButtonHbus: PropTypes.string,
    sendButtonOnClick: PropTypes.func,
    sendButtonText: PropTypes.string,
  }

  render() {
    const {
      displayErrorMessage,
      errorMessages,
      maxLength,
      onKeyUp,
      letterCount,
      sendButtonHbus,
      sendButtonOnClick,
      sendButtonText,
      isMobile,
    } = this.props;

    return (
      <div className={cx({[s.desktop]: !isMobile})}>
        <div className={s.reviewsRow}>
          <textarea className={cx(s.textbox, {[s.error]: errorMessages})} maxLength={maxLength} onKeyUp={onKeyUp}></textarea>
          <label className={cx(s.reviewLabel, {[s.error]: errorMessages, [s.active]: letterCount < maxLength})}>{'Yorum'}</label>
          <div className={cx(s.errorMessages, {[s.opacity]: displayErrorMessage})}>{errorMessages}</div>
          <span className={s.count}>{letterCount}</span>
        </div>
        <HbButton className={s.sendFeedback} onClick={sendButtonOnClick} dataHbus={sendButtonHbus} text={sendButtonText} />
      </div>
    );
  }
}

export default HbReview;
